enum TabName {
    EDIT = 'edit',
    BY_CATEGORY = 'by-category',
    ALL = 'all'
}

export default TabName;